module.exports = __webpack_public_path__ + "assets/img/img147.24afd517.png";